import React, { createContext } from 'react';
import { FeatureFlags } from './type';

const FeatureFlagsContext: React.Context<FeatureFlags> = createContext({} as FeatureFlags);

export default FeatureFlagsContext;
